import { __awaiter, __generator } from "tslib";
import { getStorage } from '../utils';
export var SENSE_KEY = '_6senseCompanyDetails';
export function load6Sense(analytics) {
    var _a;
    return __awaiter(this, void 0, void 0, function () {
        var details, reveal;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    details = getStorage(SENSE_KEY);
                    if (!details ||
                        !details.company ||
                        !details.company.domain ||
                        ((_a = analytics.group().traits()) === null || _a === void 0 ? void 0 : _a.website)) {
                        return [2 /*return*/];
                    }
                    reveal = details.company;
                    return [4 /*yield*/, analytics.group(null, {
                            website: reveal.domain,
                            intentSource: '6sense',
                            name: reveal.name,
                            country: reveal.country,
                            industry: reveal.industry,
                            number_of_employees: reveal.employee_range,
                            annual_revenue: reveal.revenue_range,
                        })];
                case 1:
                    _b.sent();
                    return [2 /*return*/];
            }
        });
    });
}
//# sourceMappingURL=6sense.js.map